<template>
  <section class="ui-section">
    <header class="ui-section__header">
      <div>
        <h1 class="ui-section__title">{{ title }}</h1>
        <p v-if="subtitle" class="ui-section__subtitle">{{ subtitle }}</p>
      </div>
      <div class="ui-section__actions">
        <slot name="actions" />
      </div>
    </header>
    <div class="ui-section__body">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  subtitle?: string
}>()
</script>

<style scoped>
.ui-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}

.ui-section__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.ui-section__title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.ui-section__subtitle {
  color: #586578;
  margin: 4px 0 0;
}

.ui-section__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 960px) {
  .ui-section {
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
